import { createContext, useContext } from 'react';
import { PrequelContextState } from './type';

/**
 * Default state for the Prequel context.
 * @type {PrequelContextState}
 */
export const defaultPrequelState: PrequelContextState = {
  prequel: {} as typeof import('@prequel/react'),
  isPrequelReady: false,
  fetchPrequelAuthToken: () => Promise.resolve(''),
};

export const PrequelContext = createContext<PrequelContextState>(defaultPrequelState);

/**
 * Custom hook to use the Prequel context.
 * @returns {PrequelContextState}
 */
export const usePrequelContext = () => {
  return useContext(PrequelContext);
};

/**
 * Custom hook to use the '@prequel/react' library.
 * @returns {typeof import('@prequel/react')}
 */
export const usePrequel = () => {
  return useContext(PrequelContext).prequel;
};

/**
 * Custom hook to use the Prequel auth functionality.
 * @returns {() => Promise<string>}
 */
export const usePrequelAuth = () => {
  return useContext(PrequelContext).fetchPrequelAuthToken;
};
